module.exports = __webpack_public_path__ + "img/corp_suggestion.72372fbd.png";